import {
  FETCH_ASSESSMENT_MESSAGES,
  UPDATE_PAGE_ASSESSMENT_MESSAGES,
} from './types';
import { CheckMessage } from 'types/check';

export interface IFetchAssessmentMessages {
  type: typeof FETCH_ASSESSMENT_MESSAGES;
  messages: CheckMessage[];
}
export interface IFetchPageAssessmentMessages {
  type: typeof UPDATE_PAGE_ASSESSMENT_MESSAGES;
  messages: CheckMessage[];
  pageNumber: number;
}

export function fetchAssessmentSuccessMessages(
  messages: CheckMessage[]
): IFetchAssessmentMessages {
  return {
    type: FETCH_ASSESSMENT_MESSAGES,
    messages,
  };
}

export function prepareUpdatePageAssessmentMessages(
  pageNumber: number,
  messages: CheckMessage[]
): IFetchPageAssessmentMessages {
  return {
    type: UPDATE_PAGE_ASSESSMENT_MESSAGES,
    messages,
    pageNumber,
  };
}
